"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zod = require("zod");
const SafeConfigSchema = _zod.z.object({
  // DCS3
  REACT_APP_DCS_ENDPOINT: _zod.z.string().url(),
  REACT_APP_DCS3_ENDPOINT: _zod.z.string().url(),
  REACT_APP_DCS_V3_ENDPOINT: _zod.z.string().url(),
  REACT_APP_DCS_CLIENT: _zod.z.string(),
  // EOS
  REACT_APP_EOS_BRAND: _zod.z.string().optional().default("L"),
  // TODO: Revisit removing .url
  REACT_APP_EOS_ENDPOINT: _zod.z.string().catch(""),
  REACT_APP_EOS_CLOUDFRONT_ENDPOINT: _zod.z.string().catch(""),
  REACT_APP_EOS_OAUTH_API_ENDPOINT: _zod.z.string().catch(""),
  REACT_APP_EOS_V2_SERVICE_MANAGEMENT_ENDPOINT: _zod.z.string().url(),
  REACT_APP_EOS_V2_VEHICLE_HEALTH_ENDPOINT: _zod.z.string().url(),
  REACT_APP_EOS_V2_VEHICLE_INFO_ENDPOINT: _zod.z.string().url(),
  REACT_APP_EOS_V2_VEHICLE_MAINTENANCE_ENDPOINT: _zod.z.string().url(),
  REACT_APP_EOS_V2_VEHICLE_MANAGEMENT_ENDPOINT: _zod.z.string().url(),
  REACT_APP_EOS_V2_VEHICLE_SUBSCRIPTION_ENDPOINT: _zod.z.string().url(),
  // Waldo
  REACT_APP_WALDO_ENDPOINT: _zod.z.string().catch(""),
  // reCaptcha
  REACT_APP_RECAPTCHA_CONSUMER: _zod.z.string().optional().default("LD"),
  REACT_APP_RECAPTCHA_KEY: _zod.z.string().catch(""),
  // Third-Parties
  REACT_APP_GOOGLE_MAP_KEY: _zod.z.string().catch(""),
  // Common
  REACT_APP_REFERRER_URL: _zod.z.string().optional().default(window.location.hostname),
  NODE_ENV: _zod.z.enum(["development", "production"]),
  REACT_APP_SCROLL_PADDING: _zod.z.enum(["noSelection", "enabled", "disabled"]).catch("noSelection")

  // TODO: Add rest of config keys
});
var _default = exports.default = SafeConfigSchema;